import React, { useState } from "react";
import { toast } from "./ui/sonner";
import { Check, X } from "lucide-react";

/* 铃铛内直接审批工程部经理的「任务链阶段校准申请」（admin / CEO） */
export function CalibDecideInline({ r, api, zh, onDone }) {
  const [state, setState] = useState(r.decided || null);
  const [rejecting, setRejecting] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  if (state) {
    const L = { approved: ["已批准并校准", "Approved"], rejected: ["已驳回", "Rejected"], cancelled: ["申请已撤回", "Cancelled"] }[state] || [state, state];
    return <span className="mt-2 inline-flex items-center gap-1 text-[11px] text-slate-500 bg-slate-100 rounded-lg px-2.5 py-1" data-testid={`reminder-calib-done-${r.id}`}>{zh ? L[0] : L[1]}</span>;
  }
  const decide = async (e, approve) => {
    e.stopPropagation();
    if (!approve && !rejecting) { setRejecting(true); return; }
    if (!approve && !note.trim()) { toast.error(zh ? "驳回须填写原因" : "Reason required"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/engine/phase-calibrations/${r.calibId}/decide`, { approve, note: note.trim() });
      setState(data.status);
      toast.success(approve ? (zh ? "已批准并完成校准" : "Approved") : (zh ? "已驳回" : "Rejected"));
      onDone?.();
    } catch (err) {
      const d = err?.response?.data?.detail || "";
      if (/已处理/.test(d)) setState("decided");
      toast.error(d || (zh ? "操作失败" : "Failed"));
    }
    setBusy(false);
  };
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2" onClick={(e) => e.stopPropagation()} data-testid={`reminder-calib-${r.id}`}>
      {rejecting && <input data-testid={`reminder-calib-note-${r.id}`} value={note} onChange={(e) => setNote(e.target.value)} placeholder={zh ? "驳回原因（必填）" : "Rejection reason"} className="h-7 rounded-md border border-rose-200 px-2 text-[11px] bg-white min-w-[200px]" />}
      <button disabled={busy} data-testid={`reminder-calib-reject-${r.id}`} onClick={(e) => decide(e, false)} className="inline-flex items-center gap-1 text-[11px] text-rose-700 bg-rose-50 border border-rose-200 hover:bg-rose-100 rounded-lg px-2.5 py-1"><X className="h-3 w-3" />{rejecting ? (zh ? "确认驳回" : "Confirm reject") : (zh ? "驳回" : "Reject")}</button>
      <button disabled={busy} data-testid={`reminder-calib-approve-${r.id}`} onClick={(e) => decide(e, true)} className="inline-flex items-center gap-1 text-[11px] text-white bg-emerald-600 hover:bg-emerald-700 rounded-lg px-2.5 py-1"><Check className="h-3 w-3" />{zh ? "批准并校准" : "Approve"}</button>
    </div>
  );
}
